import { OUTRIGHTS_CHANGED, OUTRIGHTS_CLEARED, OUTRIGHTS_PAGINATED } from '../actions/types';

const initialState = {
    pageOffset: 0,
    isFetching: false,
    isPaginating: false,
    hasNextPage: null,
    seasons: [],
    players: {},
};

const outrights = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case OUTRIGHTS_CHANGED:
            return {
                ...state,
                ...payload,
            };
        case OUTRIGHTS_PAGINATED: {
            return {
                ...state,
                ...payload,
                seasons: state.seasons.concat(payload.seasons),
            };
        }
        case OUTRIGHTS_CLEARED: {
            return initialState;
        }
        default:
            return state;
    }
};

export default outrights;
